import { DEFAULT_FORM_OPTION, FormType } from '../constant';
import { updateLandUseForm } from './landUseFormHelper';
import { updateGlasfaserRegistrationForm } from './registrationFormHelper';

const getFormType = (): FormType => {
    return (window as any).additionalPageOptions.formType || DEFAULT_FORM_OPTION;
};

const getFormUpdateFunction = (formType: FormType): Function => {
    switch (formType) {
        case FormType.REGISTRATION: return updateGlasfaserRegistrationForm;
        case FormType.LANDUSE: return updateLandUseForm;
    }
};

/**
 * Compares old state and new state entry values and returns if the state changed or not
 *
 * @export isStateChanged
 */
const isStateChanged = (newState, oldState): boolean => {
    return JSON.stringify(newState) !== JSON.stringify(oldState);
};

export { getFormType, getFormUpdateFunction, isStateChanged };
